import '@shoelace-style/shoelace/dist/themes/light.css';
import '@shoelace-style/shoelace/dist/components/drawer/drawer';

class NavigationPanel {
  constructor() {
    this.showButtonEl = document.querySelectorAll('[data-aside-toggle]');
    this.backButtonEl = document.querySelectorAll('[data-aside-back]');
    this.closeButtonEl = document.querySelectorAll('[data-aside-close]');
    this.asideEl = document.querySelectorAll('[data-aside]');

    this.asideElStack = [];

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.hideAll = this.hideAll.bind(this);

    this.addEventListeners();
  }

  addEventListeners() {
    this.showButtonEl.forEach(el => el.addEventListener('click', this.show));
    this.backButtonEl.forEach(el => el.addEventListener('click', this.hide));
    this.closeButtonEl.forEach(el => el.addEventListener('click', this.hideAll));
    this.asideEl.forEach(el => el.addEventListener('sl-request-close', evt => {
      if (evt.target === el) {
        this.hideAll();
      }
    }));
  }

  show(evt) {
    const identifier = evt.currentTarget.getAttribute('data-aside-toggle');
    const currentAsideEl = document.querySelector(`[data-aside="${identifier}"]`);
    currentAsideEl.show();

    this.asideElStack.push(currentAsideEl);
  }

  hide() {
    const currentAsideEl = this.asideElStack.pop();
    currentAsideEl.hide();
  }

  hideAll() {
    this.asideElStack.forEach(el => {
      el.hide();
    });

    this.asideElStack = []; // reset stack
  }
}

export default new NavigationPanel();
